declare namespace $ {

	type $shm_list_head__title_shm_service_task_list_1 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_service_task_list_2 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_shm_service_task_list_3 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add'] >
		,
		ReturnType< $shm_list_head['add'] >
	>
	type $shm_list_head__Close_shm_service_task_list_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $shm_list_head__Settings_shm_service_task_list_5 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Settings'] >
	>
	type $mol_list__rows_shm_service_task_list_6 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_shm_service_task_list_7 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_service_task_list_8 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_link__arg_shm_service_task_list_9 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_off_shm_service_task_list_10 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_uri'] >
		,
		ReturnType< $mol_link['uri_off'] >
	>
	type $mol_link__title_shm_service_task_list_11 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_service_task_list_12 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__event_shm_service_task_list_13 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_service_task_list['task_open'] > ): ReturnType< $shm_service_task_list['task_open'] >,
		})  & ReturnType< $mol_link['event'] >
		,
		ReturnType< $mol_link['event'] >
	>
	type $mol_link__attr_shm_service_task_list_14 = $mol_type_enforce<
		({ 
			'shm_service_task_new': ReturnType< $shm_service_task_list['task_is_new'] >,
		})  & ReturnType< $mol_link['attr'] >
		,
		ReturnType< $mol_link['attr'] >
	>
	type $mol_view__sub_shm_service_task_list_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_service_task_list extends $mol_page {
		filter( next?: string ): string
		add( next?: any ): any
		List_head( ): $shm_list_head
		Tasks( ): $mol_list
		Add_foot( ): $mol_button_major
		task_arg( id: any): Record<string, any>
		task_uri( id: any): string
		task_title( id: any): string
		task_current( id: any): boolean
		task_open( id: any, next?: any ): any
		task_is_new( id: any): boolean
		title( ): string
		add_title( ): string
		task_rows( ): readonly($mol_view)[]
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Task_link( id: any): $mol_link
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map